
const format = function () {
    var i = 0, args = arguments;
    return this.replace(/{}/g, function () {
      return typeof args[i] != 'undefined' ? args[i++] : '';
    });
  }
  
const generateFirebaseStoragePath = function(userId, accidentId, fileName){
  let storagePath = "users/" + userId + '/accidents/' + accidentId +  "/media/" + fileName
  return storagePath
}

const getFileNameFromStoragePath = function(path){
  let splitArr = path.split('/')
  const fileName = splitArr[splitArr.length - 1]
  return fileName
}

//formats array of objects to Firestore DB's schema
const formatArrayOfObjectsGoogleFirestoreDB =  function(arr){
  console.log("here")
  let dbArr = [];
  for (let obj of arr){
    let dbObj =  {
  fields: {}}
  let keys = Object.keys(obj)
    keys.forEach((key, index) => {
           dbObj.fields[key] = {"stringValue": obj[key].toString()}})
        console.log(dbObj)
        dbArr.push({"mapValue": dbObj})
  }
console.log(dbArr)
return dbArr
  }

  const parseArrayOfObjectsFirestoreDB = function(arr){
    let currArr = []
    for(let i of arr){
      let tempObj = {};
       let keys = Object.keys(i.mapValue.fields)
                               console.log(i)

        keys.forEach((key, index) => {
          console.log(i.mapValue.fields[key])
        tempObj[key] = i.mapValue.fields[key].stringValue

      })
      currArr.push(tempObj)
    
    }
    return currArr
  }
  const arrayBufferToBase64 = function( buffer ) {
    console.log(buffer)
    var binary = '';
    var bytes = new Uint8Array( buffer );
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode( bytes[ i ] );
    }
    console.log(window.btoa( binary ))
    return window.btoa( binary );
  }
   const _base64ToArrayBuffer = function(base64) {
      var binary_string = window.atob(base64);
      var len = binary_string.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
          bytes[i] = binary_string.charCodeAt(i);
      }
      return bytes.buffer;
  }
  module.exports = {format, generateFirebaseStoragePath, getFileNameFromStoragePath, formatArrayOfObjectsGoogleFirestoreDB, parseArrayOfObjectsFirestoreDB, arrayBufferToBase64, _base64ToArrayBuffer}

 


// WEBPACK FOOTER //
// ./src/common/utilityFunctions.js